$ = require 'jquery'
#Checkbox = require './components/checkbox'

$ ->
  console.log 'Загружаются модули Туртранс-Вояж...'

  require './modules/search.jquery'
  require './modules/hottours.jquery'
  require './modules/catalog.jquery'
